import classNames from "classnames";
import PropTypes from "prop-types";

const ButtonContainer = ({
  additionalClassName,
  hasFullWidthButtons,
  isMultiSelect,
  onClickSelectionButton,
  selectedButtons,
  buttons = {},
}) => {
  const buttonContainerClassName = classNames("flex gap-2 flex-wrap mt-4", {
    [additionalClassName]: additionalClassName,
    "w-full": hasFullWidthButtons,
    "flex-row": isMultiSelect,
  });

  return (
    <div className={buttonContainerClassName}>
      {Object.entries(buttons).map(([key, value]) => (
        <button
          className={classNames("px-4 py-2 rounded-full border border-onyx bg-white text-onyx", {
            "bg-wine100": selectedButtons?.has(key),
          })}
          onClick={() => onClickSelectionButton(key)}
          key={key}>
          {value}
        </button>
      ))}
    </div>
  );
};

ButtonContainer.propTypes = {
  additionalClassName: PropTypes.string,
  hasFullWidthButtons: PropTypes.bool,
  isMultiSelect: PropTypes.bool,
  onClickSelectionButton: PropTypes.func,
  selectedButtons: PropTypes.instanceOf(Set),
  buttons: PropTypes.objectOf(PropTypes.string),
};

export default ButtonContainer;
